import WorkShift from "./WorkShift";
import WorkShiftHour from "./WorkShiftHour";

export { WorkShift, WorkShiftHour };
